<div class="filter-wrapper">
  <div class="filter-header">
    <div class="title">Filter</div>
  </div>

  <div class="filter-section">
    <div class="filter-option flex-col">
      <label>Region</label>
      <p-dropdown [options]="regions" [(ngModel)]="selectedRegion" optionLabel="name" [showClear]="true" placeholder="Select Region" styleClass="region-dropdown"></p-dropdown>
    </div>

    <ng-container *ngFor="let filter of rangeFilters">
      <app-range-filter
        [label]="filter.label"
        [key]="filter.key"
        [min]="filter.min"
        [max]="filter.max"
        [step]="filter.step"
        (valueChange)="onRangeFilterChange(filter.key, $event)"
      >
      </app-range-filter>
    </ng-container>
  </div>

  <div class="buttons">
    <button class="applyBtn" (click)="applyFilters()">Apply</button>
    <button class="clearBtn" (click)="clearFilters('click')">Clear All</button>
  </div>
</div>
